export const VehicleEditSceneTranslation = {
  fi: {
    VehicleEditScene: {
      title: 'Muokkaa ajoneuvoa',
    },
  },
};
